<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
        <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->
  
            <div class="page-wrapper">
  
                    <!--begin::content-->
                    <div class="page-content">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="container-fluid">
                                            <div class="row mb-3 float-end">
                                                <button
                                                    class="btn btn-light float-end"
                                                    type="button"
                                                    data-bs-toggle="collapse" 
                                                    data-bs-target="#collapseExample" 
                                                    aria-expanded="false" 
                                                    aria-controls="collapseExample"
                                                    >
                                                    <i class="link-icon" data-feather="info"></i>
                                                    Audit Info
                                                </button>
    
                                            </div>
                                            <div class="row mb-3 float-start">
                                                <h4 class="float-start">{{$t("sales_force_opportunity_detail") }}</h4>
                                            </div>
                                            <div class="row mb-1 collapse" id="collapseExample">
                                                <div class="col-lg-3">
                                                    <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                                                    <p class="text-muted">{{this.forms.create_by}}</p>
                                                </div>
                                                <div class="col-lg-3">
                                                    <label class="tx-11 fw-bolder mb-0">Created At:</label>
                                                    <p class="text-muted">{{this.forms.created_at}}</p>
                                                </div>
                                                <div class="col-lg-3">
                                                    <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                                                    <p class="text-muted">{{this.forms.update_by}}</p>
                                                </div>
                                                <div class="col-lg-3">
                                                    <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                                                    <p class="text-muted">{{this.forms.updated_at}}</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                    
                                    <div class="card-body">
                                        <div class="row justify-content-md-center px-2">
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">{{$t('idRateSalesForce')}}</label>
                                                    <input
                                                    type="text"
                                                    class="form-control"
                                                    id="rate_header_sf_id"
                                                    :placeholder="$t('idRateSalesForce')"
                                                    v-model="forms.rate_header_sf_id"
                                                    disabled
                                                    />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">{{$t('opportunity_id')}}</label>
                                                    <input
                                                    type="text"
                                                    class="form-control"
                                                    id="opportunity_id"
                                                    :placeholder="$t('opportunity_id')"
                                                    v-model="forms.opportunity_id"
                                                    disabled
                                                    />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('contract_no')}}
                                                    </label>
                                                    <input
                                                    type="text"
                                                    class="form-control"
                                                    id="agreement_no"
                                                    :placeholder="$t('contract_no')"
                                                    v-model="forms.agreement_no"
                                                    disabled
                                                    />
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">{{
                                                    $t('warehouseId_txt')
                                                    }}</label>
                                                    <input
                                                    type="text"
                                                    class="form-control"
                                                    id="warehouse_code"
                                                    :placeholder="$t('warehouseId_txt')"
                                                    v-model="forms.warehouse_code"
                                                    disabled
                                                    />
                                                </div>
                                            </div>   
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('customerSAPCode')}}
                                                    </label>
                                                    <input
                                                    type="text" class="form-control" id="customer_code" :placeholder="$t('customerSAPCode')"
                                                    v-model="forms.customer_code" disabled/>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('effectiveFromDate')}}
                                                    </label>
                                                    <input type="text" class="form-control"
                                                    id="effective_from" :placeholder="$t('effectiveFromDate')"
                                                    v-model="forms.effective_from" disabled/>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">
                                                        {{$t('effectiveToDate')}}
                                                    </label>
                                                    <input
                                                    type="text" class="form-control" id="effective_to" :placeholder="$t('effectiveToDate')"
                                                    v-model="forms.effective_to" disabled/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="container-fluid">
                                            <button v-if="permision_role.method_read"
                                                    class="btn btn-success float-end"
                                                    @click.prevent="downloadDataBillingDetail()">
                                                    <span class="mdi mdi-download h4"></span>
                                                        {{ $t("downloadData") }} .xlsx
                                            </button>

                                        </div>
                                        <div class="card-header mb-3 mt-3">
                                            <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("detail_opportunity") }}</h6>
                                        </div>
                                        <div class="row mb-3 m-1">
                                            <vue-good-table
                                            title="list-billing-cli-billing-details"
                                            :rows="rows"
                                            :line-numbers="true"
                                            styleClass="vgt-table striped"
                                            :columns="columns"
                                            :sort-options="{
                                                enabled: true,
                                            }"
                                            :search-options="{
                                                enabled: true,
                                                trigger: 'enter',
                                            }" 
                                            >
                                            <template slot="table-row" slot-scope="props">

                                                <span v-if="props.column.field == 'price'">
                                                    {{ toCurrency(props.row.price) }}                            
                                                </span>
                                                <span v-else-if="props.column.field == 'product_descr'">
                                                    <span class="text-uppercase">{{props.row.product_descr}}</span>
                                                </span>
                                                <span v-else>
                                                    {{ props.formattedRow[props.column.field] }}
                                                </span>
                                            </template>
                                            </vue-good-table>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-primary text-light fw-bolder btn-icon-text m-1"
                                                @click="backForm" type="button">
                                                <i class="link-icon mdi mdi-arrow-left"></i>
                                                {{ $t("backMess") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end::content-->
  
  
                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->


            </div>

      </div>
    </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
    name: "SalesForceOpportunityBillingDetail",
    props: {},
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
    },
    data() {
        return {

            opens:"center",
            locale:{
                format:"yyyy-mm-dd",
            
            },
            highlighted:{

                dates: [ // Highlight an array of dates
                    new Date(),
                ],

            },
            permision_role:[],
            langs: ["id", "en"],
            detailUser: [],
            header: '',
            roleName: '',
            rate_header_sf_id:[],
            detailDivisi: [],
            totalRecords: 0,
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            companyCode: "",
            companyName:"",
            transactionFromDate:"",
            transactionToDate:"",
            columns: [
                {
                label: this.$t("idRateDetailSalesForce"),
                field: "rate_detail_sf_id",
                filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("idRateDetailSalesForce"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("product_code"),
                field: "product_code",
                filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("product_code"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("product_Desc"),
                field: "product_descr",
                filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("product_Desc"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("price"),
                field: "price",
                filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("price"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("quantity"),
                field: "qty",
                filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("quantity"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                label: this.$t("uom"),
                field: "uom",
                filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("uom"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                
                
            ],
            rows: [],
            forms: {rate_header_sf_id: "", opportunity_id: "", agreement_no: "", warehouse_code: "",  customer_code:"",  effective_from:"", effective_to:"", create_by:"", update_by:"",  status:"" , created_at:"", updated_at:""},
        };
    },
    watch: {},
    methods: {
    
    submitBillingListData(){
        console.log("ok")
    },

    cek_message(status, msg) {
          if (status == "200") {
              this.success(msg);
          }
    },

    backForm() {

        window.location.href = "/sales_force/opportunity_billing/header/";

    },

    loadData(id) {
          this.isLoading = true;

          const baseURI = this.$settings.endPointBilling + "dashboard/sales-force/opportunity-billing/header/detail/" + id;
          return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
              this.isLoading = false;
              this.forms                      = response.data.datas;
          }).catch(error => {
              this.isLoading = false;
            
        
          if(error.code == "ECONNABORTED"){
              this.error(this.$t("check_internet_connection_txt"));
              
          }else{

              if (error.response) {
                  if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      this.logout();
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
              }

          }

          });
    },


    fetchIt() {
          const userDatas     = this.$getUserInfo();
          this.userData     = userDatas.sub;
          this.roleName = userDatas.sub.role.name;
          // this.permision_role = userDatas.sub.permision_role;
          let rolePermision = [];
          userDatas.sub.permision_role.forEach(function(permision){
              if(permision.permission.controller == 'SalesForceBillingController'){

              rolePermision = permision;
              // console.log(permision);
              }
          });

          if(!rolePermision.method_read){
              this.$router.push("/authorized-error");
          }
          this.permision_role = rolePermision;

    },

    toCurrency (value) {
        if (typeof value !== "number") {
            return value;
        }
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'IDR'
        });
        return formatter.format(value);
    },

    fade(sType) {
          this.isLoading = sType;
    },

    loading() {
          this.fade(true);
          setTimeout(() => {
              this.fade(false);
          }, 1000); // hide the message after 3 seconds
    },

    resultError(data){
          var count = Object.keys(data).length;
          for (var x = 0; x < count; x++) {
              var nameOb = Object.keys(data)[x];
              var objectData = data[nameOb];
              for (var y = 0; y < objectData.length; y++) {
              this.error(objectData[y]);
              }
          }
    },

    success(kata) {
          const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
              // onShown: function() {
              //     console.log('asdasdasd');
              //     //window.location.href = '/';
              // }
          });

          Toast.fire({
              icon: "success",
              title: kata,
          });
    },

    error(kata){
          const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
          });
          Toast.fire({
              icon: "error",
              title: kata,
          });
    },

    loadDataDetails(id){
        this.isLoading = true;

        const baseURI = this.$settings.endPointBilling + "dashboard/sales-force/opportunity-billing/detail-opportunity-billing-detail/" + id+"?limit=-1";
        return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
          this.rows                  = response.data.datas.data;
          this.isLoading              = false;
        }).catch(error => {
            this.isLoading = false;
            
        
          if(error.code == "ECONNABORTED"){
              this.error(this.$t("check_internet_connection_txt"));
              
          }else{

              if (error.response) {
                  if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      this.logout();
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
              }

          }


          });
    },

    logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
    },

    downloadDataBillingDetail() {
                var params      = this.$onBehind(this.$route.params.id);
                const baseURI   = this.$settings.endPointBilling + "dashboard/sales-force/opportunity-billing/detail-opportunity-billing-detail/" + params[0] + "?download=download";
                var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
                var file_name   = "download_" + CurrentDate + ".xlsx";
         
                return this.$http
                .get(
                    baseURI,
                    {
                    responseType: "blob",
                    }
                )
                .then((response) => {
                
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
        
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
    },


    },
    events: {},
    created: function () {},
    mounted() {
        this.cek_message(this.$route.query.status, this.$route.query.msg);
        var params = this.$onBehind(this.$route.params.id);
        this.loadData(params[0]);
        this.loadDataDetails(params[0]);
        this.fetchIt();
    },

};

</script>

<style scoped>



</style>